export default __webpack_public_path__ + "static/media/bjsh-background-large.f346158c.jpg";